// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pY-z","smallCardRow":"qY-z","largeCardRow":"rY-z","productSearchRow":"sY-z","curatedRow":"tY-z"};